import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { store } from './store';
import { BrowserRouter as Router } from 'react-router-dom';
import 'zarm/dist/zarm.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { isAlpha, isRelease, isDevelopment, isProduction, isUseConsole } from './utils/env';
import { getUserInfoSync } from '@wahaha/bpm-sdk';

import 'antd-mobile/es/global';

if (isUseConsole && isDevelopment) {
  require('./vconsole');
}

if (isProduction && isAlpha) {
  require('./vconsole');
}

if (isProduction && isRelease) {
  require('./umami');
  Sentry.init({
    dsn: 'https://5958d1ef163e4cfcb968056c62b0b6aa@sentry.wahaha.com.cn/6',
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

const info = getUserInfoSync();
if (info) {
  localStorage.setItem('appToken', info.appToken);
  localStorage.setItem('userId', info.userId);
  localStorage.setItem('userName', info.userName);
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Provider store={store}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </Provider>
    </Router>
  </React.StrictMode>,

  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
